import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const operationIdState = atom<string>({
  key: 'operationIdState',
  default: '',
  effects_UNSTABLE: [persistAtom],
});
